export interface InfoDetail {
  label: string;
  value: string | JSX.Element;
  icon?: JSX.Element;
  className?: string;
}

export interface InfoSectionProps {
  title: string;
  details: InfoDetail[];
}

export function InfoSection({ title, details }: Readonly<InfoSectionProps>) {
  return (
    <div className="mb-3">
      <div className="bg-primary bg-opacity-10 rounded px-3 py-2">
        <h6 className="fw-semibold text-primary m-0">{title}</h6>
      </div>
      <div>
        {details.map((detail, idx) => (
          <div
            key={idx}
            className={`d-flex flex-column flex-md-row justify-content-between py-2 px-3 ${
              idx < details.length - 1 ? "border-bottom" : ""
            }`}
          >
            <span className="text-muted fw-semibold mb-1 mb-md-0">
              {detail.icon && <span className="me-2">{detail.icon}</span>}
              {detail.label}:
            </span>
            <span
              className={detail.className || "text-truncate"}
              style={{ maxWidth: "100%" }}
              title={typeof detail.value === "string" ? detail.value : undefined}
            >
              {detail.value}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default InfoSection;